import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaintBcbsil from "@/pages/ThankYouSaintBcbsil";
export const Route = createFileRoute("/thank-you/saint-bcbsil")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Consultation Request Received | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Thank you for requesting a SAINT® consultation and BCBSIL benefits check. A care coordinator will review your request and contact you shortly.",
        },
        {
          property: "og:title",
          content: "Consultation Request Received | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Thank you for requesting a SAINT® consultation and BCBSIL benefits check. A care coordinator will review your request and contact you shortly.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you/saint-bcbsil",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you/saint-bcbsil",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouSaintBcbsil />;
}
